export const oneOfConstants = 1

export const outputDateFormat = 'DD.MM.YYYY'

export const API_DOMEN = import.meta.env.VITE_API_URL!.replace('/api', '')
